const url = "/api/v1/";

export const state = {
    lesson: {},
    recording: false,
};

export const getters = {
    lesson: (state) => state.lesson,
    recording: (state) => state.recording,
};

export const mutations = {
    setLesson(state, lesson) {
        state.lesson = lesson;
    },
    setRecording(state, recording) {
        state.recording = recording;
    },
};

export const actions = {
    async getOne({ commit, dispatch }, id) {
        dispatch("loading/addLoading", "", { root: true });
        const res = await axios.get(url + "lessons" + "/" + id);
        commit("setLesson", res.data);
        dispatch("loading/subLoading", "", { root: true });
        return Promise.resolve(res);
    },

    async finish({ dispatch }, params) {
        dispatch("loading/addLoading", "", { root: true });
        const res = await axios.post(url + "lessons/finish", params);
        dispatch("loading/subLoading", "", { root: true });
        location.href = "/student/dashboard/programs/" + params.program_id;
        // history.back();
    },

    async saveRecord({ dispatch }, params) {
        dispatch("loading/addLoading", "", { root: true });
        const res = await axios.post(url + "lessons/save-record", params, {headers: {
                "Content-Type": "application/octet-stream"}
            });
        dispatch("loading/subLoading", "", { root: true });
        return Promise.resolve(res);
    },

    async deleteRecord({ dispatch }, params) {
        dispatch("loading/addLoading", "", { root: true });
        const res = await axios.post(url + "lessons/delete-record", params);
        dispatch("loading/subLoading", "", { root: true });
        return Promise.resolve(res);
    },

    async setRecording({ commit }, status) {
        commit("setRecording", status);
    },
};
